import React, { useEffect } from "react";
import ContactSupport from "../modals/ContactSupport";
import ContactForm from "../ContactForm";

export default function Faq() {
  useEffect(() => {
        window.scrollTo(0, 0);
  })
  return (
    <div className="container mt-5 pt-4 mb-5">

      <h1 className="fw-bold text-center mb-3 brand-purple">
        Border City Software questions and answers
      </h1>

      <p className="text-center text-muted mb-5">
        Everything you need to know about how Border City Software works.
      </p>

      <div className="bcs-faq">

        <div className="bcs-faq-item">
          <button
            className="bcs-faq-question w-100 d-flex justify-content-between align-items-center"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#faq1"
            aria-expanded="false"
            aria-controls="faq1"
          >
            What does Border City Software do
            <span className="faq-arrow">▼</span>
          </button>
          <div id="faq1" className="collapse bcs-faq-answer">
            <p>
              Border City Software creates and hosts websites for a simple monthly subscription.
              There is no large cost at the start and you can end it whenever you choose.
            </p>
          </div>
        </div>

        <div className="bcs-faq-item">
          <button
            className="bcs-faq-question w-100 d-flex justify-content-between align-items-center"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#faq2"
            aria-expanded="false"
            aria-controls="faq2"
          >
            How does the monthly subscription work
            <span className="faq-arrow">▼</span>
          </button>
          <div id="faq2" className="collapse bcs-faq-answer">
            <p>
              You pay each month for your design, hosting, updates, and support.
              Prices start at nine point five zero a month and increase with complexity.
            </p>
          </div>
        </div>

        <div className="bcs-faq-item">
          <button
            className="bcs-faq-question w-100 d-flex justify-content-between align-items-center"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#faq3"
            aria-expanded="false"
            aria-controls="faq3"
          >
            What happens if I end my subscription
            <span className="faq-arrow">▼</span>
          </button>
          <div id="faq3" className="collapse bcs-faq-answer">
            <p>
              Your website becomes inactive. Your design and assets are kept and can be reactivated if you return.
            </p>
          </div>
        </div>

        <div className="bcs-faq-item">
          <button
            className="bcs-faq-question w-100 d-flex justify-content-between align-items-center"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#faq4"
            aria-expanded="false"
            aria-controls="faq4"
          >
            Can I edit my website myself
            <span className="faq-arrow">▼</span>
          </button>
          <div id="faq4" className="collapse bcs-faq-answer">
            <p>
              Yes. You can make wording changes through a simple editor and your plan includes one larger change per month.
            </p>
          </div>
        </div>

        <div className="bcs-faq-item">
          <button
            className="bcs-faq-question w-100 d-flex justify-content-between align-items-center"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#faq5"
            aria-expanded="false"
            aria-controls="faq5"
          >
            Who owns the code and design
            <span className="faq-arrow">▼</span>
          </button>
          <div id="faq5" className="collapse bcs-faq-answer">
            <p>
              Border City Software keeps the code and system. You pay for the design, hosting, updates, and support.
            </p>
          </div>
        </div>

        <div className="bcs-faq-item">
          <button
            className="bcs-faq-question w-100 d-flex justify-content-between align-items-center"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#faq6"
            aria-expanded="false"
            aria-controls="faq6"
          >
            Can I use my own domain name
            <span className="faq-arrow">▼</span>
          </button>
          <div id="faq6" className="collapse bcs-faq-answer">
            <p>
              Yes. You can use your own domain. If I buy a domain for you up to twenty a year,
              your subscription increases to cover the cost.
            </p>
          </div>
        </div>

        <div className="bcs-faq-item">
          <button
            className="bcs-faq-question w-100 d-flex justify-content-between align-items-center"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#faq7"
            aria-expanded="false"
            aria-controls="faq7"
          >
            What support is included
            <span className="faq-arrow">▼</span>
          </button>
          <div id="faq7" className="collapse bcs-faq-answer">
            <p>
              You get general support, help when needed, and one change request each month.
            </p>
          </div>
        </div>

        <div className="bcs-faq-item">
          <button
            className="bcs-faq-question w-100 d-flex justify-content-between align-items-center"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#faq8"
            aria-expanded="false"
            aria-controls="faq8"
          >
            Where is my website hosted
            <span className="faq-arrow">▼</span>
          </button>
          <div id="faq8" className="collapse bcs-faq-answer">
            <p>
              Your site is hosted on fast and secure cloud servers with backups and strong uptime.
            </p>
          </div>
        </div>

        <div className="bcs-faq-item">
          <button
            className="bcs-faq-question w-100 d-flex justify-content-between align-items-center"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#faq9"
            aria-expanded="false"
            aria-controls="faq9"
          >
            Will my site be fast
            <span className="faq-arrow">▼</span>
          </button>
          <div id="faq9" className="collapse bcs-faq-answer">
            <p>
              Yes. All sites are built for speed, phone performance, and search engines.
            </p>
          </div>
        </div>

        <div className="bcs-faq-item">
          <button
            className="bcs-faq-question w-100 d-flex justify-content-between align-items-center"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#faq10"
            aria-expanded="false"
            aria-controls="faq10"
          >
            How do I pay each month
            <span className="faq-arrow">▼</span>
          </button>
          <div id="faq10" className="collapse bcs-faq-answer">
            <p>
              Payments are taken automatically each month with no surprise fees.
            </p>
          </div>
        </div>

        <div className="bcs-faq-item">
          <button
            className="bcs-faq-question w-100 d-flex justify-content-between align-items-center"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#faq11"
            aria-expanded="false"
            aria-controls="faq11"
          >
            Can I upgrade my site later
            <span className="faq-arrow">▼</span>
          </button>
          <div id="faq11" className="collapse bcs-faq-answer">
            <p>
              Yes. Extra pages or features can be added anytime and your plan is updated to match.
            </p>
          </div>
        </div>

        <div className="bcs-faq-item">
          <button
            className="bcs-faq-question w-100 d-flex justify-content-between align-items-center"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#faq12"
            aria-expanded="false"
            aria-controls="faq12"
          >
            How long does it take to build a site
            <span className="faq-arrow">▼</span>
          </button>
          <div id="faq12" className="collapse bcs-faq-answer">
            <p>
              A simple one page site is usually ready within a few days once I have your content.
            </p>
          </div>
        </div>
<h2 className="text-center fw-bold mb-3">More questions?</h2>
<p className="text-center text-muted">
   Feel free to contact me.
</p>

<ContactForm />
      </div>
    </div>
  );
}
